import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getClasses = createAsyncThunk("admin/allClasses", async ({ page, limit, searchData }, { rejectWithValue }) => {
  try {
    let url = `/classes/all?page=${page}&limit=${limit}`;
    if (searchData) {
      url += `&search=${searchData}`;
    }
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
export const getAllUsers = createAsyncThunk("admin/classes/users", async (_, { rejectWithValue }) => {
  try {
    let url = `/user`;
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getSingleClasses = createAsyncThunk("admin/singleClasses", async (classesId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/classes/${classesId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
export const getClassesToken = createAsyncThunk("admin/classesToken", async (classesId, { rejectWithValue }) => {
  const params = {};
  params.classesId = classesId;
  try {
    const response = await apiInstance.get(`/classes/token`, {
      headers: authHeader(),
      params,
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addClasses = createAsyncThunk("admin/addClasses", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/classes/add`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getAllExamType = createAsyncThunk("admin/allExamType", async (_,{ rejectWithValue }) => {
  try {
    const response = await apiInstance.get("/exam-type", {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editClasses = createAsyncThunk("admin/editClasses", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/classes/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteClasses = createAsyncThunk("admin/deleteClasses", async (selectedId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/classes/delete/${selectedId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  classesData: [],
};

const classesSlice = createSlice({
  name: "classesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClasses.fulfilled, (state, action) => {
      state.classesData = action.payload.data;
    });
    builder.addCase(getSingleClasses.fulfilled, (state, action) => {
      state.singleClassesData = action.payload.data;
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.userData = action.payload.data;
    });
    builder.addCase(getAllExamType.fulfilled, (state, action) => {
      state.examTypeData = action.payload.data;
    });
  },
});
export default classesSlice.reducer;
